import { Component, OnInit } from '@angular/core';
import { AuthService } from "../../../servicios/auth.service";
import { userI } from "../../../shared/models/user.interface";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Router } from "@angular/router";

import * as firebase from "firebase/app";


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(private authSvc:AuthService, private router:Router) { }

  loginForm = new FormGroup({
    email: new FormControl("", Validators.required),
    password: new FormControl("", Validators.required)
  })

  ngOnInit(): void {
   
   }

  onLogin(login:userI)
  {
    
    this.authSvc.loginByEmail(login).then(res=>
      {
       // firebase.analytics().logEvent("login",{method:"email"});
        this.router.navigate(["/"])
      })
      .catch(err=>
        {
          alert(err);
        })
  }

  registrar()
  {
    this.router.navigate(["/registro"])
  }

}
